<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { timeFormat } from '@qctsw/utils'
import { logicComplaintList } from '~/logic/complaint/useComplaintList'

const props = withDefaults(defineProps<{
  portalUserId?: number
  complaintId?: number
}>(), {
  portalUserId: 0,
  complaintId: 0,
})
const {
  data,
  pagination,
  getPage,
  state,
} = logicComplaintList()

if (props.portalUserId)
  await getPage(1, { userId: props.portalUserId })
</script>

<template>
  <div v-if="data.length > 1">
    <BasicTitle title="车主相关投诉" class="mb-6" />
    <div class="user-complaint">
      <div class="flex item-header leading-11.25">
        <div class="w-37.5 text-center">
          投诉ID
        </div>
        <div class="flex-grow min-w-0 text-center">
          投诉标题
        </div>
        <div class="w-50 text-center">
          投诉时间
        </div>
      </div>
      <NuxtLink
        v-for="v in data" :key="v.id"
        :to="APP_ROUTER.complaintDetail(v.id)"
        class="flex items-center leading-12.5 item hover:text-orange-6"
      >
        <template v-if="v.id !== props.complaintId">
          <div class="w-37.5 text-center flex items-center justify-center flex-shrink-0">
            QT{{ v.id }}
          </div>
          <div class="flex-grow min-w-0 text-center line-clamp-1">
            {{ v.title }}
          </div>
          <div class="w-50 text-center flex-shrink-0">
            {{ timeFormat(v.createTime, 'YYYY-MM-DD HH:mm') }}
          </div>
        </template>
      </NuxtLink>
      <BasicLoadButton class="bg-slate-2" :state="state" @load="() => getPage(pagination.pagination.page, { userId: props.portalUserId })" />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.user-complaint {
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #f2f5fa;
}

.item-header {
  background-color: #f2f5fa;
}

.item {
  border-top: 1px solid #f2f5fa;
}
</style>
